import React from "react";
import "../../styles/whychoose.scss";
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Typography, Box
} from '@material-ui/core';


function BbysTable(props) {

  const rows = [
    {
      label: "What do you need?",
      option1: (
        <>
          - Home sale contingency removed<br />
          - Faster Purchase Price Guarantee (PPG) turnaround time<br />
          - Lower fees<span >*</span>
        </>
      ),
      option2: (
        <>
          - A higher offer to clear mortgage balance on departing residence<br />
          - A second lien to unlock equity
        </>
      )
    },
    {
      label: "How Fast Do You Need It?",
      option1: "1-2 business days",
      option2: "5-7 business days"
    },
    {
      label: "Allows you to tap into equity",
      option1: <img src="/assets/images/wrong_icon.png" />,
      option2: <img src="/assets/images/right_icon.png" />
    },
    {
      label: "PPG Amount",
      option1: "Minimum amount required to clear the home sale contingency plus closing costs",
      option2: "Varies by home and market"
    },
    {
      label: "Calque's Program Fee",
      option1: (
        <>
          ${parseInt(props.partner.administrative_fees.replace(/,/g, "").split('.')[0], 10).toLocaleString("en-US")} + {props.partner.calque_percentage_fee}% of the PPG<br />
          <span>*Lower PPGs = Lower Fees</span>
        </>
      ),
      option2: `$${parseInt(props.partner.administrative_fees.replace(/,/g, "").split('.')[0], 10).toLocaleString("en-US")} + ${props.partner.calque_percentage_fee}% of the PPG`
    },
    {
      label: "Calque Resale Guarantee",
      option1: <img src="/assets/images/right_icon.png" />,
      option2: <img src="/assets/images/right_icon.png" />
    }
  ];

  return (
    <div className="bbys-table-main-container inter">
      <div style={{ textAlign: "center" }}>
        <h2 className="new-heading" style={{ marginBottom: "10px" }}>
          Two Great Ways To{" "}
          <span
            style={{
              color: "#4594CB",
            }}
          >
            Buy-Before-You-Sell
          </span>
        </h2>
        <h3
          className="new-sub-main-heading"
          style={{ textDecoration: "none", color: "#8D8D8D" }}
        >
          Pick the product that's right for you
        </h3>
      </div>
      <div className="bbys-table-container">
        <TableContainer style={{ borderRadius: 2,padding:'10px 0px 20px 0px'}}>
          <Table style={{
             minWidth: 900,
             borderCollapse: 'separate',
             borderSpacing: 0
          }}>
            <TableHead >
              <TableRow>
                <TableCell style={{ fontWeight: 600,border:"none" }}></TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontWeight: 600,
                    borderLeft: '1px solid #2b84c3',
                    borderTop: '1px solid #2b84c3',
                    borderRight: '1px solid rgb(251, 192, 78)',
                    backgroundColor: '#fff',
                    fontFamily:'inter',
                    fontSize:'22px',
                    borderTopLeftRadius:'10px'
                  }}
                >
                  Option 1: Contingency Buster
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontWeight: 'bold',
                    color: '#fff',
                    backgroundColor: '#5ea1d1',
                    fontFamily:'inter',
                    fontSize:'22px',
                    border: '1px solid rgb(251, 192, 78)',
                    borderLeft: '1px solid rgb(251, 192, 78)',
                    borderTopRightRadius:'10px'
                  }}
                >
                  Option 2: {props?.partner?.partner_program_name}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow
                  key={index}
                >
                  <TableCell
                    style={{
                          ...(index === 0 ? { borderTopLeftRadius: '10px',borderTop: '1px solid #2b84c3' } : {}),
                          ...(index === rows.length - 1 ? { borderBottomLeftRadius: '10px'} : {}), 
                    fontWeight: 600, borderLeft: '1px solid #2b84c3',borderBottom: '1px solid #2b84c3',fontFamily:'inter',fontSize:'20px',textAlign:'center',width:'35%' }}
                  >
                    {row.label}
                  </TableCell>
                  <TableCell style={{  ...(index === 0 ? { borderTop: '1px solid #2b84c3' } : {}),borderLeft: '1px solid #2b84c3',borderBottom: '1px solid #2b84c3',fontFamily:'inter',fontSize:'18px',color:'#7a7a7a',textAlign:'center' }}>{row.option1}</TableCell>
                  <TableCell style={{ ...(index === rows.length -1 ? { borderBottomRightRadius: '10px'} : {}),
                  borderBottom: '1px solid rgb(251, 192, 78)',borderLeft: '1px solid rgb(251, 192, 78)',borderRight: '1px solid rgb(251, 192, 78)',fontFamily:'inter',fontSize:'18px',color:'#7a7a7a',textAlign:'center'}}>{row.option2}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div
        className="bbys-text-container"
        style={{ backgroundColor: props?.partner?.primary_color || "#2A83C2" }}
      >
        <div>
          <img src="/assets/images/resale_guarantee_icon.png" />
        </div>
        <div>
          <p className="calque-resale-guarantee-text">
            If Calque purchases the departing residence and resells it for more
            than the PPG amount, Calque will refund the profit net of all
            expenses, including but not limited to the purchase price,
            commissions, interest, taxes, title, and other fees.
          </p>
        </div>
      </div>
    </div>
  );
}

export default BbysTable;
